import { useQuery } from "react-query";
import AuthApiClient from "api/AuthApiClient";
import PersonsApiClient from "api/PersonsApiClient";

export const createContextPersonKey = () => ["context"];

async function getContextAndRefreshIfNotAuth() {
    const context = await PersonsApiClient.getContext();

    if (context.isAuthenticated) {
        return context;
    }

    try {
        await AuthApiClient.refresh();
        return await PersonsApiClient.getContext();
    } catch {
        return context;
    }
}

export function useContextPerson() {
    const contextQuery = useQuery(createContextPersonKey(), getContextAndRefreshIfNotAuth, {
        refetchInterval: 60 * 1000 /* ms */,
        refetchOnWindowFocus: true,
    });

    return {
        ...contextQuery.data,
        isLoading: contextQuery.isLoading,
    };
}
